import axios from 'axios';
export class AgentSecurityError extends Error {
    constructor(message, code) { super(message); this.code = code; }
}
export const agentError = e => ({
    9999:'로그인이 만료되었습니다. 다시 로그인해주세요.', 4230:'PIN 인증이 잠겼습니다. 잠금 상태를 다시 확인해주세요.',
    4010:'인증 정보가 일치하지 않습니다.', 4031:'SUPER 권한이 필요합니다.',
    4032:'보안 검증에 실패했습니다. 설정을 다시 조회해주세요.',
    4090:'설정이 변경되었습니다. 다시 조회 후 확인해주세요.',4091:'인증 버전 또는 요청 번호가 충돌했습니다. 결과와 설정을 다시 확인해주세요.',
    4100:'인증이 만료되었거나 내용이 변경되었습니다. 송금 접수 여부를 확인한 뒤 다시 인증해주세요.',
    4290:'요청이 너무 많습니다. 잠시 후 다시 시도해주세요.',
    5031:'인증 설정을 확인하지 못했습니다. 인증 없이 진행할 수 없습니다.',
    5033:'영업자 PIN 기능이 아직 설치되지 않았거나 비활성 상태입니다.',
})[e?.code] || e?.message || '처리 결과를 확인하지 못했습니다.';
export async function agentApi(path, {method='get', body, csrf}={}) {
    if(method!=='get' && (typeof csrf!=='string'||!csrf.trim())) throw new AgentSecurityError('보안 토큰을 다시 조회해주세요.');
    let response;
    try {
        const config={withCredentials:true,timeout:15000};
        response=method==='get' ? await axios.get(process.env.REACT_APP_API+path,config)
            : await axios[method](process.env.REACT_APP_API+path,body,{...config,headers:{'Content-Type':'application/json','X-CSRF-Token':csrf}});
    } catch(e) {
        // A missing route/proxy endpoint is not an expired login session, even
        // when its error body happens to contain code 9999. Never redirect for it.
        if (e.response?.status === 404) throw new AgentSecurityError('인증 API를 찾을 수 없습니다(404). 서버 연결을 확인한 뒤 다시 조회해주세요.', 404);
        throw new AgentSecurityError(e.response?.data?.msg || '응답을 받지 못했습니다. 상태를 다시 확인해주세요.', e.response?.data?.code);
    }
    if(response.data?.code!==1000)throw new AgentSecurityError(response.data?.msg,response.data?.code);
    return response.data.data;
}
export function validateAgentSettings(data) {
    if(typeof data?.enabled!=='boolean' || typeof data?.login?.required!=='boolean' || typeof data?.withdraw?.required!=='boolean'
        || !Number.isSafeInteger(data.version) || typeof data.pin_registered!=='boolean' || typeof data.recovery_required!=='boolean'
        || !Number.isFinite(data.locked_until) || typeof data.csrf_token!=='string' || !data.csrf_token.trim()) throw new AgentSecurityError('PIN 설정 응답이 올바르지 않습니다.');
    for(const policy of [data.login,data.withdraw])if(policy.required && (policy.method!=='PIN'||policy.allowed?.length!==1||policy.allowed[0]!=='PIN'))throw new AgentSecurityError('지원하지 않는 인증 정책입니다.');
    return data;
}
export const getAgentSettings=async()=>validateAgentSettings(await agentApi('/api/agent-security/settings'));
export function validateAgentTransferPolicy(data, flow, amountSemantics) {
    const semantics=amountSemantics || (flow==='BANK_ACCOUNT_V2'?'RECEIVER_AMOUNT':'DEBIT_TOTAL');
    if(data?.supported!==true || data.flow!==flow || data.amount_semantics!==semantics || typeof data.pin_required!=='boolean'
        || typeof data.registration_required!=='boolean' || typeof data.policy_version!=='string')throw new AgentSecurityError('출금 정책을 확인하지 못했습니다. 신규 출금을 진행할 수 없습니다.');
    if(data.pin_required && (typeof data.pin_registered!=='boolean'||typeof data.csrf_token!=='string'||!data.csrf_token.trim()))throw new AgentSecurityError('송금 PIN 설정을 다시 확인해주세요.');
    if(data.accepting_requests===false)throw new AgentSecurityError('신규 송금 접수가 중단되었습니다. 기존 요청 결과는 확인할 수 있습니다.');
    return data;
}
export const getAgentTransferPolicy=async (flow,amountSemantics)=>validateAgentTransferPolicy(await agentApi('/api/agent-wallet/transfer-policy'),flow,amountSemantics);
export const agentPost=(path,body,csrf)=>agentApi('/api/agent-security/'+path,{method:'post',body,csrf});
export function pinBody(settings,password,pin,repeat,management,recovery) {
    if(!/^\d{4}$/.test(pin)||pin!==repeat)throw new Error('새 PIN 4자리와 확인 값이 일치해야 합니다.');
    if(/^(\d)\1{3}$/.test(pin)||'0123456789'.includes(pin)||'9876543210'.includes(pin))throw new Error('반복되거나 연속된 PIN은 사용할 수 없습니다.');
    if(!password)throw new Error('현재 로그인 비밀번호를 입력해주세요.');
    const body={password,pin,expected_version:settings.version};
    if(settings.recovery_required){if(!recovery?.trim())throw new Error('관리자에게 전달받은 복구 권한을 입력해주세요.');body.recovery_authorization=recovery.trim();}
    else if(settings.pin_registered){if(!management||management.expiresAt<=Date.now())throw new Error('기존 PIN을 다시 인증해주세요.');body.management_authorization=management.authorization;}
    return body;
}
export const agentTransferFingerprint=c=>JSON.stringify([c.requestId,c.amount,c.fee,c.amountSemantics,c.recipient?.bankCd,c.recipient?.account]);
export function agentPermitValid(permit,confirmation) {
    return !!confirmation && permit?.fingerprint===agentTransferFingerprint(confirmation) && (!permit.required || (permit.expiresAt>Date.now() && !!permit.authorization && !!permit.csrfToken));
}
